import { BaseState, StateManager } from '@app/store/shared';
import { createReducer, on } from '@ngrx/store';
import { contentBlockActions } from '../actions/content-block.actions';
import { ContentBlock } from '../models';

export type ContentBlockState = Record<string, BaseState<ContentBlock[]>>;

const initialState: ContentBlockState = {};

export const contentBlockReducer = createReducer(
    initialState,
    on(contentBlockActions.getContentBlock, (state, payload): ContentBlockState => {
        return {
            ...state,
            [payload.id]: StateManager.setLoading(state[payload.id]),
        };
    }),
    on(contentBlockActions.getContentBlockSuccess, (state, payload): ContentBlockState => {
        return {
            ...state,
            [payload.id]: StateManager.setLoaded(state[payload.id], payload.blocks),
        };
    }),
    on(contentBlockActions.getContentBlockError, (state, payload): ContentBlockState => {
        return {
            ...state,
            [payload.id]: StateManager.setError(state[payload.id]),
        };
    }),
    on(contentBlockActions.clear, (): ContentBlockState => {
        return { ...initialState };
    }),
);
